"use client";

import { Grid, Box, SxProps, Theme } from "@mui/material";

interface TwoColumnProps {
  children: React.ReactNode;
  align?: "flex-start" | "center";
}

interface ColumnProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

export function TwoColumnItem({ children, sx }: ColumnProps) {
  return (
    <Grid size={{ xs: 12, sm: 6 }}>
      <Box sx={sx}>{children}</Box>
    </Grid>
  );
}

export const TwoColumn = ({ children, align = "flex-start" }: TwoColumnProps) => {
  return (
    <Grid
      container
      spacing={{ xs: 4, sm: 6 }}
      sx={{
        marginY: {
          xs: 4, // 32px mobile
          sm: 6, // 48px desktop
        },
        alignItems: align,
      }}
    >
      {children}
    </Grid>
  );
};
